export default __webpack_public_path__ + "static/media/services_connexion.cd43195e.svg";